import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { Alert } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { stopShowing } from '@/app/common/reducers/helpersShowSlice';
import IconButton from './IconButton';
import type { ReactNode } from 'react';

type HelpersShowState = string[];

interface SingleAlertForExportProps {
  helpersShowState: HelpersShowState;
  id: string;
  html: ReactNode;
}

const SingleAlertForExport = ({
  helpersShowState,
  id,
  html,
}: SingleAlertForExportProps) => {
  const [show, setShow] = useState(true);
  const dispatch = useDispatch();

  return (
    <>
      {!helpersShowState?.includes(id) && (
        <Alert
          show={show}
          variant="info"
          className="d-flex align-items-center fs--1 my-2"
        >
          <div
            className="bg-info d-flex flex-center me-2 rounded-circle shadow-sm border-0"
            style={{ height: '2rem', width: '2rem' }}
          >
            <FontAwesomeIcon
              icon={['far', 'file-excel']}
              className="text-white fs-0"
            />
          </div>
          <div className=" flex-1 ">
            <p className="mb-0 ps-1 text-justify pe-3">{html}</p>
          </div>
          <span>
            <IconButton
              data-dismiss="alert"
              aria-label="Close"
              icon={['far', 'thumbs-up']}
              variant="falcon-primary"
              iconClassName="me-2"
              onClick={() => {
                setShow(false);
                dispatch(stopShowing(id));
              }}
              className=" w-100 w-lg-auto fs--2 fw-bold mt-lg-0"
            >
              متوجه شدم
            </IconButton>
          </span>
        </Alert>
      )}
    </>
  );
};

const ExportHelpAlert = () => {
  const helpersShowState = useSelector(
    (state: { helpersShow: HelpersShowState }) => state.helpersShow,
  );

  return (
    <SingleAlertForExport
      id="exportHelper"
      helpersShowState={helpersShowState}
      html="برای گرفتن خروجی (excel و csv) داخل جدول کلیک راست کنید."
    />
  );
};

export default ExportHelpAlert;
